// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__15oO3","rootSmall":"AddTileButton_rootSmall__glr4T"};